var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    comboItems: _vm.comboDocumentTypeItems,
                    itemText: "codeName",
                    itemValue: "code",
                    type: "search",
                    name: "ramDocumentTypeCd",
                    label: "자료구분",
                  },
                  model: {
                    value: _vm.searchParam.ramDocumentTypeCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "ramDocumentTypeCd", $$v)
                    },
                    expression: "searchParam.ramDocumentTypeCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "관련자료 목록",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            gridHeight: _vm.grid.height,
            selection: _vm.popupParam.type,
            rowKey: "documentId",
          },
          on: { rowDblclick: _vm.rowDblclick },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "documentTitle"
                    ? [
                        _vm.hasDetail(props.row)
                          ? _c("q-btn", {
                              staticClass: "tableinnerBtn tableinnerBtn-left",
                              attrs: {
                                align: "left",
                                flat: "",
                                color: "blue-6",
                                label: props.row.documentTitle,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.linkClick(props.row)
                                },
                              },
                            })
                          : _c("span", [
                              _vm._v(_vm._s(props.row.documentTitle)),
                            ]),
                        props.row.documentSubTitle
                          ? _c("div", { staticClass: "description-td" }, [
                              _vm._v(
                                " " + _vm._s(props.row.documentSubTitle) + " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBLSELECT", icon: "check" },
                        on: { btnClicked: _vm.select },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }